<template>
  <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit">
    <FormItem prop="userName">
      <Input v-model="form.userName" placeholder="请输入用户名">
      <span slot="prepend">
        <Icon :size="16" type="ios-person"></Icon>
      </span>
      </Input>
    </FormItem>
    <FormItem prop="password">
      <Input type="password" v-model="form.password" placeholder="请输入密码">
      <span slot="prepend">
        <Icon :size="14" type="md-lock"></Icon>
      </span>
      </Input>
    </FormItem>
    <FormItem>
      <Button @click="handleSubmit" :disabled="!agreementAccepted" type="primary" long>登录</Button>
      <div class="login-agreement">
        <Checkbox v-model="agreementAccepted" aria-label="同意用户协议与隐私政策" />
        <span>我已阅读并同意<button
          type="button"
          class="agreement-link"
          @click.stop="agreementVisible = true"
          @keydown.enter.stop
        >《用户协议与隐私政策》</button></span>
      </div>
      <div class="login-links">
        <a @click="resigt">{{ getWeb.is_open_student_register == 2 ? '注册' : '' }}</a>
        <a @click="getPwd">忘记密码</a>
      </div>
    </FormItem>
    <Modal v-model="agreementVisible" title="用户协议与隐私政策" :width="720">
      <div class="agreement-content" v-html="getWeb.login || ''"></div>
      <div slot="footer">
        <Button @click="agreementVisible = false">关闭</Button>
      </div>
    </Modal>
  </Form>
</template>
<script>
  import { mapActions, mapMutations } from "vuex";
  export default {
    name: 'LoginForm',
    props: {
      userNameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '账号不能为空', trigger: 'blur' }
          ]
        }
      },
      passwordRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '密码不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data() {
      return {
        form: {
          userName: '',
          password: ''
        },
        getWeb: {},
        agreementAccepted: false,
        agreementVisible: false
      }
    },
    computed: {
      rules() {
        return {
          userName: this.userNameRules,
          password: this.passwordRules
        }
      }
    },
    created() {
      this.getWebInfo()
    },
    methods: {
      ...mapActions(["getCompany"]),
      ...mapMutations(["setCompany"]),
      handleSubmit() {
        if (!this.agreementAccepted) {
          this.$Message.warning('请先阅读并同意用户协议与隐私政策')
          return
        }
        this.$refs.loginForm.validate((valid) => {
          if (valid && this.agreementAccepted) {
            this.$emit('on-success-valid', {
              userName: this.form.userName,
              password: this.form.password
            })
          }
        })
      },
      getWebInfo() {
        this.$axios
          .get("/app/auth/getWebInfo")
          .then((res) => {
            if (res.code == 1) {
              this.getWeb = res.data
              this.setCompany(res.data.company_name);
              window.document.title = res.data.company_name
            } else {
              this.$Message.error(res.msg);
            }
          });
      },
      resigt() {
        if (this.getWeb.is_open_student_register == 2) {
          P
          this.$router.replace({ name: "Register" });
        }

      },
      getPwd() {
        this.$router.replace({ name: "ForgetPwd" });
      }

    }
  }
</script>
<style scoped lang="less">
  .login-links {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
  }
  .login-agreement {
    display: flex;
    align-items: center;
    margin: 10px 0;
    font-size: 12px;
    line-height: 1.6;
    .ivu-checkbox-wrapper {
      flex-shrink: 0;
      margin-right: 4px;
      line-height: 1;
    }
  }
  .agreement-link {
    padding: 0;
    border: 0;
    background: transparent;
    color: #2d8cf0;
    font: inherit;
    cursor: pointer;
    &:hover {
      color: #57a3f3;
    }
  }
  .agreement-content {
    max-height: 65vh;
    overflow: auto;
    overflow-wrap: break-word;
    /deep/ img {
      max-width: 100%;
      height: auto;
    }
  }
</style>
